//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'footInfo',
    components: {

    },
    data () {
        return {

        }
    },
    methods:{
        copy (str) {
            var save = function(e){
                e.clipboardData.setData('text/plain',str);
                e.preventDefault();
            }
            document.addEventListener('copy',save);
            document.execCommand('copy');
            document.removeEventListener('copy',save);
        },
        sharewx(){
           var ua = navigator.userAgent.toLowerCase(); 
           if(ua.match(/MicroMessenger/i)=="micromessenger") { //微信自带浏览器
                alert('点击右上角即可分享')
            } else {  //非微信自带浏览器
                this.$vux.toast.show({
                    type: 'success',
                    text: '复制成功，去粘贴分享给微信好友吧'
                })
                this.copy(location.href)
                setTimeout(() => {
                    window.location.href = 'weixin://';
                }, 1000);
            }
        },
        sharewb(){
            this.$vux.toast.show({
                type: 'success',
                text: '复制成功，去粘贴分享到微博吧'
            })
            this.copy(location.href)
            // setTimeout(() => {
            //     window.location.href = 'mqqwpa://im/chat?chat_type=wpa&version=1&src_type=web&web_src=oicqzone.com';
            // }, 1000);
        },
        shareqq(){
            this.$vux.toast.show({
                type: 'success',
                text: '复制成功，去粘贴分享给QQ好友吧'
            })
            this.copy(location.href)
            setTimeout(() => {
                window.location.href = 'mqqwpa://im/chat?chat_type=wpa&version=1&src_type=web&web_src=oicqzone.com';
            }, 1000);
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/footInfo.vue